import i from 'i18next'
import { useEffect } from 'react'
import { motion } from 'framer-motion'
import useTranslations, { getTranslations } from 'lib/hooks/use-translations'
import { getMenu, getMenuCollections } from 'lib/hooks/use-collections'
import Layout from 'components/Layout'
import Title from 'components/Title'
import Footer from 'components/sections/Footer'
import Head from 'next/head'

export async function getStaticProps() {
	const translations = await getTranslations({ page: 'stores' })
	const nav = await getMenu()
	const collections = await getMenuCollections()
	return {
		props: { translations, nav, collections },
		revalidate: 600,
	}
}

export default function Stores({ loaded, translations, nav, collections }) {
	useTranslations( translations )

	const init = () => {
		// @ts-ignore
		window.StoreRocket?.init({
			selector: '.widget',
			account: 'Y287qdA4AP',
		})
	}

	useEffect( () => {
		const script = document.getElementById( 'storerocket' )
		if ( !script ) {
			const script = document.createElement( 'script' )
			script.id = 'storerocket'
			script.src = '//cdn.storerocket.io/widget.js'
			script.onload = init
			document.head.appendChild( script )
		} else {
			// Small pause to make sure the target element exists in DOM
			setTimeout( init, 100 )
		}
	}, [] )

	return (
		<Layout loaded={loaded} nav={nav} collections={collections}>
			<Head>
				<meta name="robots" content="noindex" />
			</Head>
			<Title page="stores" />
			<motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{ delay: 1 }}
			>
				<section className="cf">
					<h1>{i.t( 'stores.title' )}</h1>
					<div className="widget">
						<p>{i.t( 'stores.loading' )}</p>
					</div>
				</section>
			</motion.div>
			<Footer />
			<style jsx>{`
				h1 {
					margin-bottom: 1em;
				}
			`}</style>
		</Layout>
	)
}
